















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';

@Component
export default class ChunkUploader extends Vue {
    @Prop({
        type: String,
        required: true
    })
    endpoint: any;

    @Prop({
        type: Number,
        default: 1024
    })
    chunkSize: any;

    @Prop({
        type: String,
        default: ''
    })
    extAllowed: any;

    @Prop({
        type: Number,
        default: 1024
    })
    maxSizeAllowedKb: any;

    @Prop({
        type: Number,
        default: 3
    })
    maxParallelUpload: any;

    @Prop({
        type: Boolean,
        default: null,
    })
    state: any;

    @Prop({
        type: Boolean,
        default: null,
    })
    resetButton: any;
    

    file: any = [];
    chunks: any = [];        
    uploadDone: boolean = false;
    curresntStatus: string = '';
    //chunkSize: number = 2048 * 1024;
    //currentChunk: number = 0;
    processedChunk: number = 0;
    sessionId: number = 0;
    processId: string = '';
    fileName: string = '';
    progressComputed: number = 0;
    get cunkSent(): number {
        let counter: number = 0;
        for (var i = 0; i < this.chunks.length; i++) {
            if (this.chunks.sent == true) counter++;
        }
        console.log(counter)
        return counter;
    }
    get chunkSizeInKb() {
        return this.chunkSize * 1024;
    }
   
    updateProgress() {
        let perc: number = Math.floor((this.processedChunk * 100) / (this.chunks.length - 1));
        this.progressComputed = perc;
        this.$emit('progress', this.progressComputed);
        console.log(perc)
        if (perc>=100) console.log("Ok")
    }
    updateProgressDo(e: any) {
        
        this.$emit('progress');
    }
    formData(nChunk: number) {
        
        
        
        
        let formData = new FormData;
        let isLast: boolean = (this.chunks.length - 1 == nChunk);
        formData.set('is_last', (isLast).toString());
        formData.set('start_offset', (nChunk * this.chunkSizeInKb).toString());
        formData.set('session_id', (this.sessionId).toString());
        formData.set('file', this.chunks[nChunk].content, `${this.file.name}.part`);
        
        
        
        return formData;
    }

    @Watch('file')
    fileChange(fileVal: any) {
        this.file = fileVal;
        let app = this;
        this.$emit('file', this.file);
        if(this.file != null){
            let checkExt = this.checkAllowedExtensions(this.file.name, this.extAllowed);
        if (!checkExt) {
            General.showAlertDanger('Only ' + this.extAllowed + ' extension is allowed', app);
            return;
        }
        let checkSize = this.checkSize(this.file.size, this.maxSizeAllowedKb);
        if (!checkSize) {
            General.showAlertDanger('Your file exceeds the maximum size allowed (' + this.showSize(this.maxSizeAllowedKb) + ')', app);
            return;
        }
        this.createChunks();
        //this.currentChunk = 0;
        this.upload(0);
        }
       
    }
    private showSize(sizeInKb: number): string {
        console.log(sizeInKb)
        let sizeInByte = sizeInKb*1024;
        if (sizeInByte < 1024) return sizeInByte + ' Kb';
        return Math.floor(sizeInByte / 1024 / 1024) + ' Mb';
    }
    private getExtension(fileName: string): string {
        let nameSplitted = fileName.split('.');
        return nameSplitted[1];
    }
    private checkAllowedExtensions(fileName: string, extAllowed: string): boolean {
        if (extAllowed == '') return true;
        let extSplitted = extAllowed.split(',');
        let currentExt: string = this.getExtension(fileName);
        let find: boolean = false;
        extSplitted.forEach(function (ext: string) {
            if (ext.trim().toLowerCase() == currentExt.trim().toLowerCase()) {
                find = true;
            }
        });
        return find;
    }
    private checkSize(fileSizeByte: number, fileSizeAllowedKb: number): boolean {

        if (fileSizeByte > fileSizeAllowedKb  * 1024) return false;
        return true;
    }
    async upload(nChunk: number) {
       
        if (nChunk >= this.chunks.length) return;
       
        this.progressComputed = 100;
        this.updateProgress();
        let app = this;
        this.chunks[nChunk].sent = true;

        
  

        var response = await axios({
            method: 'post',
            data: this.formData(nChunk),
            url: General.GetApiUrl(this.endpoint),
            responseType: 'json',
            withCredentials: true,
            headers: {
                'Content-Type': 'application/octet-stream'
            },
        });
        
        try{
       
            if (nChunk == 0) {
                app.sessionId = response.data.sessionId;
            }
            if (response.data.processId) app.processId = response.data.processId;
            app.curresntStatus = response.data.status;

            if (response.data.processId) {
                app.uploadDone = true;
                app.$emit('completed', app.processId);
                return;
            }
            app.processedChunk++;
            app.updateProgress();
            app.uploadBlock(nChunk);
        }catch(error) { 
            General.HandleError(error, app);
        };
    }
    uploadBlock(nChunkStart: number) {
        let end: number = nChunkStart + this.maxParallelUpload;
        //for (let i: number = nChunkStart; i < end; i++) {
        //let next = i + 1;
        //  if (i >= this.chunks.length) break;
        //console.log(this.chunks[i].sent)
        //if (this.chunks[nChunkStart].sent == false) this.upload(nChunkStart);
        this.upload(nChunkStart + 1)
        //}
    }
    createChunks() {
        
        this.$emit('getfilename', this.file.name);            
        let chunks = Math.ceil(this.file.size / this.chunkSizeInKb);
        //console.log('size: ' + this.file.size)
        //console.log('chunkSizeInKb: ' + this.chunkSizeInKb)
        for (let i = 0; i < chunks; i++) {
            this.chunks.push({
                sent: false,
                content: this.file.slice(
                    i * this.chunkSizeInKb, Math.min(i * this.chunkSizeInKb + this.chunkSizeInKb, this.file.size), this.file.type
                )
            });
            //console.log(this.chunks[i])
        }
    }
   
    reset(){
        
        this.progressComputed = 0;
        this.sessionId=0;
        this.chunks = [];                        
        this.curresntStatus = '';
        this.processedChunk = 0;
        this.fileName = '';
        this.file = null;
        this.uploadDone = false;
        this.updateProgress();
        this.$emit('reset');
    }
}
